import React from "react";
import { Create } from "react-admin";

import { useMutateForm } from "../../../api/useMutateForm";
import { orderWarningValidations } from "../../../components/_helpers/warningsConditions";
import { SimpleFormAdv } from "../../../components/forms/SimpleFormAdv";
import { SaveButtonWithSaveToEditWithCancelWithCopyDocumentsToolbar } from "../../../components/toolbars/SaveButtonWithSaveToEditWithCancelWithCopyDocumentsToolbar";
import { OrderService } from "../../../entities";
import { FormCustomer } from "../forms/FormCustomer";
import { FormManager } from "../forms/FormManager";
import { transformCustomFieldData } from "../forms/shared";

export const makeOrderCreate = (Form) => (props) => {
	const [mutateForm, state] = useMutateForm("create", props.resource, props.basePath, null, {}); // eslint-disable-line
	const toolbarCompProps = {
		warningValidations: orderWarningValidations,
	};

	const handleSave = (data, ...args) => {
		const transformed = transformCustomFieldData(data);
		return mutateForm(transformed, ...args);
	};

	return (
		<Create {...props}>
			<SimpleFormAdv
				save={handleSave}
				redirect="show"
				initialValues={{
					commodity_id: null,
					split_load: false,
					priority: false,
					service: null,
					plumb: false,
					seal: false,
					printed_doc: false,
				}}
				toolbarComp={SaveButtonWithSaveToEditWithCancelWithCopyDocumentsToolbar}
				toolbarCompProps={toolbarCompProps}
			>
				<Form isAddMode={true} />
			</SimpleFormAdv>
		</Create>
	);
};

export const OrderCreate = makeOrderCreate(FormManager);
export const OrderCreateByManager = OrderCreate;
export const OrderCreateByCustomer = makeOrderCreate(FormCustomer);
